import { JSONSchema4 } from "json-schema";
import { CardsDataSourceComponent } from "./CardsDataSourceComponent";

export interface CardsDataSource {
  /**
   * Gets a data source component for the given path.
   */
  getDataSourceComponent(path?: string, specData?: { [key: string]: any }, contextParams?: { [key: string]: string } ): CardsDataSourceComponent;

  getDisplayName(): string;

  getDataSourceConfigSpec(): Promise<JSONSchema4>;

  getDataSourcePaths(specData?: { [key: string]: any }): Promise<{ name: string, path: string }[]>;
}
